/*
 * Copyright © 2025. Legalbird eine Marke der Legalbird GmbH
 */

import React from "react";
import Grid from "@mui/material/Grid";
import CheckIcon from "../../../assets/icons/common/toggleable/IconCheck";
import CrossIcon from "../../../assets/icons/common/toggleable/IconClose";
import { isIban, isMoney, requiredValidator } from "../../../services/validationRules";
import { useForm } from "../../../provider/Form/FormProvider";
import ValidatorTextField from "../../FormFields/ValidatorTextField";
import Group from "../../Wizard/Group";
import FormLegend from "../Common/FormLegend/FormLegend";
import wizardStyle from "../wizardStyle";
import InputAdornment from "@mui/material/InputAdornment";
import { IbanInput } from "../../FormFields/MaskedInputs/IbanInput";
import ValidatorMultiSelectFieldWithCheckboxes from "../../FormFields/ValidatorMultiSelectFieldWithCheckboxes";
import { translate } from "../../../services/translations/translations";
import ClientClaimedData from "../AbstractLitigationCase/ClientClaimedData";

const BaseEnforceClaim = () => {
  const { values } = useForm();

  return (
    <>
      <Grid sx={wizardStyle.gridTopSpaced} size={12}>
        <FormLegend>Welches Ziel verfolgen Sie? Sie können hier auch mehrere Ziele auswählen.</FormLegend>
      </Grid>
      <Grid size={12}>
        <ValidatorMultiSelectFieldWithCheckboxes
          label="Zielsetzung"
          name="objectivesClient"
          validators={[requiredValidator("Bitte geben Sie Ihr Ziel an")]}
          options={[
            { value: "payment", label: translate("generalCivilLaw.objectivesClient.options.payment.label", {}) },
            { value: "injunction", label: translate("generalCivilLaw.objectivesClient.options.injunction.label", {}) },
            { value: "removal", label: translate("generalCivilLaw.objectivesClient.options.removal.label", {}) },
            { value: "handover", label: translate("generalCivilLaw.objectivesClient.options.handover.label", {}) },
            { value: "other", label: translate("generalCivilLaw.objectivesClient.options.other.label", {}) },
          ]}
        />
      </Grid>
      {values.objectivesClient.indexOf("payment") > -1 && (
        <Grid size={12}>
          <Group
            type="radio"
            name="isDamageQuantifiable"
            question="Lässt sich die Höhe der gewünschten Zahlung / des entstandenen Schadens genau beziffern? "
            options={[
              {
                labelText: "Ja, der Schaden lässt sich beziffern",
                labelIcon: <CheckIcon />,
                labelIconActive: <CheckIcon active />,
                value: "yes",
              },
              {
                labelText: "Nein, der Schaden lässt sich nicht beziffern",
                labelIcon: <CrossIcon />,
                labelIconActive: <CrossIcon active />,
                value: "no",
              },
            ]}
            validators={[requiredValidator("Bitte wählen Sie eine der angezeigten Antworten aus")]}
          />
        </Grid>
      )}
      {values.objectivesClient.indexOf("payment") > -1 && values.isDamageQuantifiable === "yes" && (
        <>
          <Grid sx={wizardStyle.gridTopSpaced} size={12}>
            <FormLegend>Wie viel Geld möchten Sie einfordern?</FormLegend>
          </Grid>
          <Grid size={12}>
            <ValidatorTextField
              label="Schaden in €"
              name="claimedAmountClient"
              validators={[
                requiredValidator("Bitte geben Sie Ihre Forderung an."),
                {
                  validator: isMoney,
                  message: "Bitte geben Sie den Wert in Euro und Cent ein - zum Beispiel 136,15 oder 85,00",
                },
              ]}
              helperText="Bitte geben Sie den Wert in Euro und Cent ein - zum Beispiel 136,15 oder 85,00"
            />
          </Grid>
          <Grid sx={wizardStyle.gridTopSpaced} size={12}>
            <FormLegend>Wie lautet Ihre Bankverbindung, auf die der geforderte Betrag überwiesen werden soll?</FormLegend>
          </Grid>
          <Grid size={12}>
            <ValidatorTextField
              label="IBAN für Rückerstattung"
              name="client.bankData.iban"
              validators={[
                {
                  validator: isIban,
                  message: "Die eingegebene IBAN ist ungültig",
                },
              ]}
              InputProps={{
                startAdornment: <InputAdornment position="start">DE</InputAdornment>,
                inputComponent: IbanInput,
              }}
              helperText={"Wenn Sie die IBAN gerade nicht wissen, lassen Sie das Feld gerne einfach leer."}
            />
          </Grid>
        </>
      )}
      <ClientClaimedData />
    </>
  );
};
export default BaseEnforceClaim;
